import React from "react";
import { useLanguage, useT } from "@/lib/LanguageContext";
import CrmDialog from "../ui/CrmDialog";
import CaptureFormView from "./CaptureFormView";
import { CRM } from "../../../constants/testIds/crm";

/** "Preview" (design §E.4): the same read-only CaptureFormView, in a modal. */
export default function FormPreviewDialog({ open, onClose, practiceName, host, form }) {
  const t = useT("crm");
  const { lang } = useLanguage();
  const consentText = form?.consent_text?.[lang] || form?.consent_text?.en || "";
  return (
    <CrmDialog open={open} onOpenChange={(o) => { if (!o) onClose(); }} title={t("forms.previewTitle")} size="lg" testId={CRM.formsPreviewDialog}>
      <CaptureFormView practiceName={practiceName} host={host} fields={form?.fields} consentText={consentText} />
    </CrmDialog>
  );
}
